export default __webpack_public_path__ + "static/media/Main.869024bb.jpg";